import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-warning\"><path d=\"M2.73 20 12 4l9.269 16H2.73Zm1.72-1h15.1L12 6 4.45 19ZM12 17.616c.174 0 .32-.06.438-.177a.596.596 0 0 0 .177-.439.596.596 0 0 0-.177-.439.595.595 0 0 0-.438-.177.596.596 0 0 0-.439.177.596.596 0 0 0-.177.439c0 .174.06.32.177.439a.596.596 0 0 0 .439.177Zm-.5-2.232h1v-5h-1v5Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol